import { axiosInstance } from '@src/services/common';

export async function getCriticalEvents() {
  const response = await axiosInstance.get<{ critical_events: CriticalEvent[] }>(
    `/gm/v1/critical_events`,
  );

  return response.data.critical_events;
}

export async function getCriticalEvent(id: string) {
  const response = await axiosInstance.get<{ critical_event: CriticalEvent }>(
    `/gm/v1/critical_events/${id}`,
  );

  return response.data.critical_event;
}

export async function postCriticalEvent(
  data: Pick<CriticalEvent, 'name' | 'is_milestone' | 'rules'>,
) {
  const response = await axiosInstance.post<{ critical_event: CriticalEvent }>(
    `/gm/v1/critical_events`,
    data,
  );

  return response.data.critical_event;
}

export async function putCriticalEvent(value: {
  id: string;
  data: Pick<CriticalEvent, 'name' | 'is_milestone'> & Partial<Pick<CriticalEvent, 'rules'>>;
}) {
  await axiosInstance.put<{ critical_event: CriticalEvent }>(
    `/gm/v1/critical_events/${value.id}`,
    value.data,
  );
}

export async function deleteCriticalEvent(id: string) {
  await axiosInstance.delete(`/gm/v1/critical_events/${id}`);
}

export interface QueryCriticalEventRequest {
  name: string;
  rules: CriticalEventRule[][];
}

export interface QueryCriticalEventResponse {
  data: Record<string, string>;
  time_range: [string, string];
}

export async function queryCriticalEvent(payload: QueryCriticalEventRequest) {
  const response = await axiosInstance.post<QueryCriticalEventResponse>(
    `/gm/v1/critical_event/query`,
    payload,
  );

  return response.data;
}
